<script lang="ts">
	import PreGame from "./PreGame.svelte";
	import Game, { GameInitSettings } from "./Game.svelte";
	import Results, { ResultsData } from "./Results.svelte";
	let gameInitSettings: GameInitSettings|null= null;
	let results: ResultsData | null = null; 
	function startGame(newSettings: GameInitSettings) {
		gameInitSettings = newSettings;
	}

	function finishGame({ correct, incorrect }: { correct: string[], incorrect: string[] }) {
		gameInitSettings = null;
		results = {
			correct,
			incorrect
		};
	}

	function reset() {
		gameInitSettings = null;
		results = null;
	}
</script>

<main>
	{#if gameInitSettings}
		<Game gameInitSettings={gameInitSettings} finishGameCallback={finishGame}></Game>
	{:else if results}
		<Results results={results} newGameCallback={reset}></Results>
	{:else}
		<PreGame startGameCallback={startGame} />
	{/if}
</main>

<style>
	main {
		text-align: center;
		max-width: 240px;
		margin: 0 auto;
		height: 100%;
	}
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>